import { DataTableV2, Intro } from "components/commons";
import { locale } from "localization/en";
import ExpenseFilter from "./expense-filter";
import { useMount, useRouter, useAlert } from "hooks";
import { Path, FormMode } from "enums";
import { useContext, useState } from "react";
import { StationContext } from "contexts";
import { expenseLogsColumn } from "./expense-list-column";
import { mapDataToList, mapFilterToRequest } from "./expense-list-mapper";
import { getExpenseListApi } from "apis";
import { initialFilterState } from "./expense-filter.state";
import useDataTable from "hooks/useDataTable";
import ImageCarousel from "components/commons/image-carousel/image-carousel";

const ExpenseModule = () => {
  const { station } = useContext(StationContext);
  const [imageUrl, setImageUrl] = useState("");
  const { addAlert } = useAlert();

  useMount(() => {
    console.log(station.stationCode);
  });

  const { filter, search, table } = useDataTable({
    api: {
      api: getExpenseListApi,
      params: {
        page: 1,
        perPage: 10,
        stationCode: station.stationCode,
      },
      mapper: (param) => {
        return param;
      },
    },
    filter: {
      initialState: initialFilterState(),
      mapper: mapFilterToRequest,
      disregardFilterCount: {
        dateBy: true,
      },
    },
    table: {
      key: "expenses",
      mapper: (expenses) =>
        mapDataToList({
          expenses,
          imageUrl,
          onClickViewSlip: (imageUrl) => {
            if (!imageUrl) {
              return addAlert({
                title: "Oops! No Image to Show",
                subtitle: "This image isn't available right now. Please check back later.",
                type: "error",
                interval: 3000,
              });
            }
            setImageUrl(imageUrl);
          },
          onClickView: (expenseId) => {
            router.push(Path.ViewExpenseDetails(expenseId, FormMode.View));
          },
        }),
      columns: expenseLogsColumn,
    },
  });

  const router = useRouter();
  return (
    <div>
      <Intro title={locale.expenses} />
      <ExpenseFilter {...filter} {...search} />
      <DataTableV2 {...table} />
      <ImageCarousel value={imageUrl} onClose={() => setImageUrl("")} />
    </div>
  );
};

export default ExpenseModule;
